// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"735":"6a9c5b7c","1536":"6a9c5b7c","2863":"6a9c5b7c","4487":"6a9c5b7c","5147":"6a9c5b7c","7906":"6a9c5b7c","7915":"6a9c5b7c"}[chunkId] + ".chunk.css";
};